import { supportedBillingCurrencies } from 'obt-common';

/*
  Made return type as object in hope sometime later this will be replaced with BE endpoint, and we can extend it with isLoading prop
*/
export interface UseAvailableBillingCurrenciesResult {
  supportedCurrencies: typeof supportedBillingCurrencies;
}

export const useAvailableBillingCurrencies = (): UseAvailableBillingCurrenciesResult => {
  // Cleaned up old Optimizely logic with dynamic currency list since those have been fully rolled out for some time.
  // Keeping hook since there are discussions underway on making currency management easier/more dynamic.
  return { supportedCurrencies: supportedBillingCurrencies };
};
